import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'antd';
import Input from '../../ui/Input';
import { PlusOutlined } from '@ant-design/icons';
import Collapse, { Panel } from '../../ui/Collapse';
import './index.css'


const FormItem = Form.Item

interface propsTypes {
    detailData: object | any,
    currentForm: any,
    setValidateCount: any,
    validateCount: number
}
interface dataType {
    name: string
}

const GeneralCertificationsEdit = (props: propsTypes) => {

    //must rerender Collapse after add as we need new active keys
    const [refreshCount, setRefreshCount] = useState(0)
    const data = props?.detailData?.environmentalimpact?.general?.certifications || []
    const [detailData, setDetailData] = useState(data)
    const [isValidate, setIsValidate] = useState(false)


    //only need to change data which can controlling Panel rendering
    const deleteItem = (index: number) => {
        const validData = detailData.filter((item: { name: string; }, i: number) => item)
        props.currentForm.setFieldsValue({
            [`general-certifacations-${index}`]: null
        })
        if (validData.length === 1) {
            setIsValidate(false)
            props.currentForm.validateFields([[`general-certifacations-1`]])
        } else {
            const _detailData = JSON.parse(JSON.stringify(detailData))
            _detailData[index] = null
            setDetailData(_detailData)
        }
        props.setValidateCount(props.validateCount + 1)
        // const _detailData  = JSON.parse(JSON.stringify(detailData))
        // _detailData[index].name = null
        // setDetailData(_detailData)
    }

    //need add certifaction object and refresh active keys of <Collapse />, which means we need to rerender <Collapse />
    const addCertification = () => {
        if (!isValidate) {
            setIsValidate(true)
        }
        const newDetails = detailData.concat([{ name: ' ' }])
        setDetailData(newDetails)
        props.setValidateCount(props.validateCount + 1)
        setRefreshCount(refreshCount + 1)
    }

    useEffect(() => {
      props.setValidateCount((prev : any)=> prev + 1) 
     }, [])

    return (
        <>
            <Collapse
                defaultActiveKey={detailData.map((_: object, i : number) => i)}
                multiCollapseButton
                key={refreshCount}
            >
                <>
                    {
                        detailData.map((item: { name: string }, i: number) => (
                            <React.Fragment key={i}>
                                {item ? <Panel
                                    header={`Certification ${i + 1}`}
                                    key={i}
                                    deleteButton={{
                                        action: () => deleteItem(i),
                                        title: `Are you sure you want to delete Certification ${i + 1}?`,
                                    }}
                                >
                                    <Row gutter={24}>
                                        <Col span={8}>
                                            <FormItem
                                                name={`general-certifacations-${i}`}
                                                label="Name"
                                                rules={[
                                                    { required: isValidate, message: 'This field is required' },
                                                    { max: 64, message: 'You have reached the max character length of 64' }
                                                ]}
                                            >
                                                <Input maxLength={64} onChange={() => props.setValidateCount((prev : any)=> prev + 1)} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Panel> : null}
                            </React.Fragment>
                        ))
                    }
                </>
            </Collapse>
            <Button
                type="link"
                onClick={() => {
                    addCertification()
                }}
                icon={<PlusOutlined />}
                style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
            >
                {`Add Certification ${detailData.length + 1}`}
            </Button>
        </>
    )
}

export default GeneralCertificationsEdit;

